import constant from "lib/constant/constant";

const cmsVendorList = (cms) => {
  const cmsData = {
    sortOptions: [
      { label: cms("label.providerList.sortByDateAsc"), value: cms("label.providerList.createdAtAsc") },
      { label: cms("label.providerList.sortByDateDesc"), value: cms("label.providerList.createdAtDesc") },
      { label: cms("label.providerList.sortByBrandNameAsc"), value: cms("label.providerList.brandNameAsc") },
      { label: cms("label.providerList.sortByBrandNameDesc"), value: cms("label.providerList.brandNameDesc") },
    ],
    promotedBulkActions: [
      {
        content: cms("label.providerList.bulkAction"),
      },
    ],
    resourceName: {
      singular: cms("label.providerList.Vendor"),
      plural: cms("label.providerList.Vendors"),
    },
    filterOptions: [
      { label: cms("label.providerList.brand"), value: constant.BRAND_NAME },
      { label: cms("label.providerList.platform"), value: constant.LIVECONNECTED_PLATFORM },
      { label: cms("label.providerList.method"), value: constant.PAYMENT_METHOD },
    ],
    message: {
      something_went_wrong: cms("error.common.somethingWentWrong"),
      running_background: cms("message.providerList.requestSuccess"),
      token_expire: cms("message.providerList.token_expire"),
      enterAccessCode: cms("message.providerList.enterAccessCode"),
      vendorEnable: cms("message.providerList.enable"),
      vendorDisable: cms("message.providerList.disable"),
    },
    label: {
      approved: cms("label.providerList.approved"),
      show_all_vendor: cms("label.providerList.showAllVendor"),
      select_filter: cms("label.providerList.selectFilter"),
      like: cms("label.providerList.like"),
      filter_by: cms("label.providerList.filterBy"),
      verify_selected: cms("label.providerList.verifySelected"),
      delete_selected: cms("label.providerList.deleteSelected"),
      search: cms("label.providerList.search"),
      tabKey: cms("label.providerList.tabKey"),
      sort_name: cms("label.providerList.sortName"),
      sort_order: cms("label.providerList.sortOrder"),
      perPage: cms("label.providerList.perPage"),
      list_filter: cms("label.providerList.listFilter"),
      list_search: cms("label.providerList.listSearch"),
      filter: cms("label.providerList.filter"),
      total: cms("label.providerList.total"),
      deleteModal: cms("label.providerList.deleteModal"),
      delete: cms("label.providerList.delete"),
      primaryDelete: cms("label.providerList.primaryDelete"),
      secondaryDelete: cms("label.providerList.secondaryDelete"),
      reason: cms("label.providerList.reason"),
      logInModal: cms("label.providerList.logInModal"),
      logInAs: cms("label.providerList.logInAs"),
      fullAccess: cms("label.providerList.fullAccess"),
      onlyReadAccess: cms("label.providerList.onlyReadAccess"),
      otpModal: cms("label.providerList.otpModal"),
      enterCode: cms("label.providerList.enterCode"),
      viewDetailsFor: cms("label.providerList.viewDetailsFor"),
      name: cms("label.providerList.name"),
      email: cms("label.providerList.email"),
      onBoardedOn: cms("label.providerList.onBoardedOn"),
      page: cms("label.providerList.page"),
      onHold: cms("label.providerList.onHold"),
      reject: cms("label.providerList.rejected"),
      review: cms("label.providerList.review"),
      needReview: cms("label.providerList.needReview"),
      inReview: cms("label.providerList.inReview"),
      hold: cms("label.providerList.hold"),
      rejected: cms("label.providerList.rejectVendor"),
      doNothing: cms("label.providerList.doNothing"),
      rejectOrder: cms("label.providerList.reject"),
      critical: cms("label.providerList.critical"),
      disabled: cms("label.providerList.disable"),
    },
    helpText: {
      doHelpText: cms("helpText.provider.allOrder"),
      rejectHelpText: cms("helpText.provider.reject"),
      doHelpTextCR: cms("helpText.provider.enable"),
    },
    sectionContent: {
      deleteVendorSelected: cms("sectionContent.providerList.deleteVendorSelected"),
      logInAsAccess: cms("sectionContent.providerList.logInAsAccess"),
      otpNote: cms("sectionContent.providerList.otpNote"),
    },
    button: {
      deleteFromMc: cms("button.providerList.deleteProvider.primaryAction"),
      deleteFromShop: cms("button.providerList.deleteProvider.secondaryAction1"),
      confirmOtp: cms("button.providerList.accessCodeVerify.primaryAction"),
      resendOtp: cms("button.providerList.accessCodeVerify.secondaryAction1"),
      readOnly: cms("button.providerList.accessCodeVerify.secondaryAction2"),
      brandPage: cms("button.providerList.providerList.secondaryAction3"),
      brandPageV2: cms("button.providerList.providerList.secondaryAction4"),
      deleteVendor: cms("button.providerList.providerList.primaryAction"),
      loginVendor: cms("button.providerList.providerList.secondaryAction1"),
      reviewVendor: cms("button.providerList.providerList.secondaryAction7"),
      enableVendor: cms("button.providerList.providerList.secondaryAction5"),
      disableVendor: cms("button.providerList.providerList.secondaryAction6"),
      profile: cms("button.providerList.providerList.profile"),
    },
    limitOptions: [
      { label: "10", value: 10 },
      { label: "20", value: 20 },
      { label: "50", value: 50 },
      { label: "100", value: 100 },
    ],
    // tabs: [
    //   {
    //     id: "all-vendors",
    //     content: cms("label.providerList.all"),
    //     accessibilityLabel: "All vendors",
    //     panelID: "allVendorContent",
    //     value: "all",
    //   },
    //   {
    //     id: "pending-approval",
    //     content: cms("label.providerList.pendingApproval"),
    //     panelID: "pendingApprovalContent",
    //     value: "pending",
    //   },
    //   {
    //     id: "approved",
    //     content: cms("label.providerList.approved"),
    //     panelID: "approvedContent",
    //     value: "approve",
    //   },
    //   {
    //     id: "review",
    //     content: cms("label.providerList.review"),
    //     panelID: "reviewContent",
    //     value: "inReview",
    //   },
    //   {
    //     id: "onHold",
    //     content: cms("label.providerList.onHold"),
    //     panelID: "onHoldContent",
    //     value: "onHold",
    //   },
    //   {
    //     id: "rejected",
    //     content: cms("label.providerList.rejected"),
    //     panelID: "rejectedContent",
    //     value: "reject",
    //   },
    //   {
    //     id: "onHoliday",
    //     content: cms("label.providerList.onHoliday"),
    //     panelID: "onHolidayContent",
    //     value: "onHoliday",
    //   },
    // ],
    filterStatus: [
      {
        label: cms("label.providerList.all"),
        value: "all",
      },
      {
        label: cms("label.providerList.pendingApproval"),
        value: "pending",
      },
      {
        label: cms("label.providerList.approved"),
        value: "approve",
      },
      {
        label: cms("label.providerList.review"),
        value: "inReview",
      },
      {
        label: cms("label.providerList.onHold"),
        value: "onHold",
      },
      {
        label: cms("label.providerList.rejected"),
        value: "reject",
      },
      {
        label: cms("label.providerList.onHoliday"),
        value: "onHoliday",
      },
    ],
  };

  return cmsData;
};

export default cmsVendorList;
